// Product card hover video: a card whose second media is a video (snippets/card-product.liquid renders a <video class="card-video"> with
// data-src only) plays it on hover or keyboard focus. The src is set on first use. Desktop hover only, and not with reduced motion:
// phones and those shoppers keep the still photo. Leaving pauses and rewinds.
if (!window.cardVideoInit) {
  window.cardVideoInit = true;
  const allowed = () => window.matchMedia('(hover: hover) and (min-width: 799px) and (prefers-reduced-motion: no-preference)').matches;
  const videoOf = (node) => node.closest?.('.product-wrap')?.querySelector('.card-video');

  const start = (event) => {
    const video = allowed() && videoOf(event.target);
    if (!video) return;
    if (!video.getAttribute('src')) {
      video.src = video.dataset.src;
      video.load();
    }
    if (video.paused) video.play().catch(() => {});
  };
  const stop = (event) => {
    const wrap = event.target.closest?.('.product-wrap');
    const video = wrap?.querySelector('.card-video');
    if (!video || (event.relatedTarget && wrap.contains(event.relatedTarget))) return;
    video.pause();
    video.classList.remove('is-playing');
    if (video.readyState) video.currentTime = 0;
  };
  document.addEventListener('mouseover', start);
  document.addEventListener('focusin', start);
  document.addEventListener('mouseout', stop);
  document.addEventListener('focusout', stop);
  document.addEventListener('playing', (event) => event.target.classList?.contains('card-video') && event.target.classList.add('is-playing'), true);
}
